import type { KeyValueRepository } from './KeyValueRepository'

export class LocalKeyValueRepository implements KeyValueRepository {
  get(key: string): string | null {
    if (typeof window === 'undefined') return null
    try {
      return window.localStorage.getItem(key)
    } catch {
      return null
    }
  }

  set(key: string, value: string): boolean {
    if (typeof window === 'undefined') return false
    try {
      window.localStorage.setItem(key, value)
      return true
    } catch {
      return false
    }
  }

  remove(key: string): void {
    if (typeof window === 'undefined') return
    try {
      window.localStorage.removeItem(key)
    } catch {
      // 清理失败不阻断主流程。
    }
  }
}
